import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { NIPIGE_BASE_URL } from "@/config";

class Api {
  public $http: AxiosInstance;

  constructor(data: AxiosRequestConfig = {}) {
    const conf: AxiosRequestConfig = {
      baseURL: NIPIGE_BASE_URL,
      ...data
    };
    this.$http = axios.create(conf);
    this.$http.interceptors.request.use(this.attachToken);
  }

  private attachToken(config) {
    const userLogin = sessionStorage.getItem("userLogin") || "";
    const userRole = sessionStorage.getItem("userRole");
    const userKey = sessionStorage.getItem("nipige:key");
    if (userLogin) {
      const { token } = JSON.parse(userLogin);
      config.headers.Authorization = `Bearer ${token}`;
      if (userKey) {
        config.headers["x-encrypted-key"] = userKey;
      }
    } else {
      if (userRole === "Partner" && userKey) {
        config.headers["x-encrypted-key"] = userKey;
      }
      config.headers.Authorization = "";
    }
    return config;
  };
}

export default (payload = {}) => {
    return new Api(payload);
}
